/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Advantage_UploadsInputs */

const en_plan_advantage_uploads = /** @type {(inputs: Plan_Advantage_UploadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited uploads & syncing across devices`)
};

const es_plan_advantage_uploads = /** @type {(inputs: Plan_Advantage_UploadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subidas ilimitadas y sincronización entre dispositivos`)
};

/**
* | output |
* | --- |
* | "Unlimited uploads & syncing across devices" |
*
* @param {Plan_Advantage_UploadsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_advantage_uploads = /** @type {((inputs?: Plan_Advantage_UploadsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Advantage_UploadsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_advantage_uploads(inputs)
	return en_plan_advantage_uploads(inputs)
});